const indexItems = [
  { id: 1, title: '2026暑期档明星恋情大起底', count: 34, tag: '热门' },
  { id: 2, title: '热门综艺录制黑幕大揭秘', count: 28, tag: '独家' },
  { id: 3, title: '直播圈主播塌房事件全收录', count: 45, tag: '热议' },
  { id: 4, title: '微博热搜第一背后的真实故事', count: 19, tag: '追踪' },
  { id: 5, title: '明星夫妻离婚内幕深度挖掘', count: 22, tag: '深度' },
  { id: 6, title: '饭圈互撕前因后果完整时间线', count: 31, tag: '热门' },
  { id: 7, title: '网红人设崩塌事件全纪录', count: 37, tag: '火爆' },
];

export default function IndexSection() {
  return (
    <section id="index" className="section-anchor py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">吃瓜专题合集</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">按专题整理的911吃瓜爆料合集，一站式查看完整事件脉络</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="flex items-start justify-between mb-3">
                <span className={`px-2 py-0.5 rounded text-xs font-semibold ${
                  item.tag === '热门' || item.tag === '火爆' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '独家' ? 'bg-accent-100 text-accent-800' :
                  item.tag === '深度' ? 'bg-secondary-100 text-secondary-800' :
                  'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
                <span className="text-xs text-foreground-500">{item.count}条</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexItems.slice(4, 7).map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="flex items-start justify-between mb-3">
                <span className={`px-2 py-0.5 rounded text-xs font-semibold ${
                  item.tag === '热门' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '深度' ? 'bg-secondary-100 text-secondary-800' :
                  'bg-secondary-100 text-secondary-700'
                }`}>{item.tag}</span>
                <span className="text-xs text-foreground-500">{item.count}条</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}